import React from 'react';
import './About.css';
import aboutPhoto from '../assets/gallery/about.jpg';

function About() {
  return (
    <section id="about" className="about section">
      <div className="container about-grid">
        <div className="about-visual">
          <div className="about-photo-wrap">
            <img 
              src={aboutPhoto} 
              alt="Our Chef" 
              className="about-photo"
            />
            <div className="about-card-overlay">
              <div className="card-overlay-text">
                <span className="card-tag"></span>
          
              </div>
            </div>
          </div>
          <div className="about-badge"><span>Since</span><strong>1998</strong></div>
        </div>
        <div className="about-text">
          <span className="section-label">Our Story</span>
          <h2 className="section-heading">From Karaikudi's<br/><em>Ancient Kitchens</em></h2>
          <p>Chettinad cuisine is one of India's most celebrated culinary traditions — bold, aromatic, and deeply rooted in heritage. Our family has preserved these authentic flavors for over more than 25 years.</p>
          <p>Every dish is a celebration of the Nattukotai Chettiar community's wisdom — from stone-grinding fresh masalas each morning to slow-cooking gravies in traditional clay pots.</p>
          <div className="about-hl">
            <div className="hl-card"><span className="hl-icon">🌿</span><div><strong>Fresh Daily Masalas</strong><p>Stone-ground spice blends every morning</p></div></div>
            <div className="hl-card"><span className="hl-icon">🍃</span><div><strong>Banana Leaf Service</strong><p>Traditional serving for authentic experience</p></div></div>
            <div className="hl-card"><span className="hl-icon">🔥</span><div><strong>Wood-Fire Cooking</strong><p>Clay pots and wood-fire for authentic taste</p></div></div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;